import type {SearchParams} from '@/modules/common/context/QueryParams/models';
import type {SearchFormValues} from '@travel-frontend/ui-components';

import {omit} from 'lodash';
import {useEffect, useMemo, useState} from 'react';

import {mapSearchParamsToFormValues} from '@/modules/common/components/SearchBar/utils';
import {useKeywordData} from '@/modules/common/hooks/useKeywordData';

export const useSearchFormPersistentValues = ({
  searchParams,
  destinationId,
}: {
  searchParams: SearchParams;
  destinationId: string | null | undefined;
}): SearchFormValues => {
  const keywordData = useKeywordData(destinationId || '');
  const [destinationFieldValue, setDestinationFieldValue] = useState<any>(null);

  useEffect(() => {
    if (keywordData.status !== 'successful' || !keywordData.data) {
      return;
    }
    // "keyword-api/keywords"-endpoint returns an additional "travelTypes"-field that is not present in the "keyword-api/autocomplete"-endpoint response.
    // This field would break the equality check in the search form however, so we need to remove it.
    setDestinationFieldValue(omit(keywordData.data, 'travelTypes'));
  }, [keywordData.status, keywordData.data]);

  return useMemo(
    () => ({
      ...mapSearchParamsToFormValues(searchParams),
      destination: destinationFieldValue,
    }),
    [searchParams, destinationFieldValue]
  );
};
